import * as TYPES from './types';
import http from '@/utils/api';
import Auth from '@/utils/auth';

const namespaced = true;

const state = () => ({
  refusals: null,
  model: null,
  questions: null,
  answers: [],
  price: 0,
  loading: false,
  error: {
    show: false,
    type: '',
  },
  errorSearch: '',
})

const actions = {
  async getAllRefused ({ commit }, data) {
    try {
      const response = await http.get('/refusal', {
        headers: {
          'Authorization': Auth.getAuthHeader()
        }
      })
      commit(TYPES.SET_REFUSALS, response.data);
    } catch(e) {
      console.log(e);
    }
  },
  
  async searchModel ({ commit }, data) {
    commit(TYPES.SET_LOADING, true);
    try {
      const response = await http.post('/watch/create', data, {
        headers: {
          'Authorization': Auth.getAuthHeader()
        }
      })

      if (response.data.ErrorDetails)
        commit(TYPES.SET_ERROR_SEARCH, 'Устройство не найдено в системе, проверьте SN. Если все верно, обратитесь в чат технической поддержки.');
      else
        commit(TYPES.SET_MODEL, response.data);

      commit(TYPES.SET_LOADING, false);

      return response.data;
    } catch(e) {
      // const { response } = e;
      commit(TYPES.SET_LOADING, false);
      commit(TYPES.SET_ERROR_SEARCH, 'Устройство не найдено в системе, проверьте SN. Если все верно, обратитесь в чат технической поддержки.');

      // if (response) {
      //   commit(TYPES.SET_ERROR, 'error');
      // }
    }
  },

  async changeModel ({ commit }, data) {
    try {
      const response = await http.put('/watch/redefine', data, {
        headers: {
          'Authorization': Auth.getAuthHeader()
        }
      })
      commit(TYPES.SET_MODEL, response.data);
    } catch(e) {
      console.log(e);
    }
  },

  async getQuestions ({ commit }, data) {
    commit(TYPES.RESET_QUESTINS);
    try {
      const response = await http.get('/watch/questions', {
        headers: {
          'Authorization': Auth.getAuthHeader()
        },
      })
      commit(TYPES.SET_QUESTIONS, response.data);
    } catch(e) {
      console.log(e);
    }
  },

  async getCalc ({ commit }, data) {
    
    try {
      commit(TYPES.SET_LOADING, true);
      const response = await http.post('/watch/calc', data, {
        headers: {
          'Authorization': Auth.getAuthHeader()
        },
      })
      commit(TYPES.SET_PRICE, response.data);
      commit(TYPES.SET_GRADE, response.data);
      commit(TYPES.SET_LOADING, false);
    } catch(e) {
      commit(TYPES.SET_LOADING, false);
      console.log(e);
    }
    
  },

  async agreeModel ({ commit }, data) {
    try {
      const response = await http.post('/watch/agree', data, {
        headers: {
          'Authorization': Auth.getAuthHeader()
        },
      });
      return true;
    } catch(e) {
      console.log(e);
    }
  },

  async cancelModel ({ commit }, data) {
    try {
      const response = await http.post('/watch/refused', data, {
        headers: {
          'Authorization': Auth.getAuthHeader()
        },
      });
      return true;
    } catch(e) {
      console.log(e);
    }
  },
}

const mutations = {
  [TYPES.SET_ERROR_SEARCH](state, payload) {
    state.errorSearch = payload;
  },

  [TYPES.SET_LOADING](state, payload) {
    state.loading = payload;
  },

  [TYPES.SET_REFUSALS](state, payload) {
    state.refusals = payload;
  },

  [TYPES.SET_PRICE](state, payload) {
    state.price = payload.price;
  },

  [TYPES.SET_GRADE](state, payload) {
    state.grade = payload.grade;
  },

  [TYPES.SET_MODEL](state, payload) {
    state.model = payload;
  },

  [TYPES.RESET_MODEL](state, payload) {
    state.model = null;
  },

  [TYPES.SET_QUESTIONS](state, payload) {
    let questions = payload.groups;
    let answers = [];
    questions.map((item, i) => {
      if (i == 0) {
        item.active = true;
      } else {
        item.active = false
      }
      item.questions.map((item2, i2) => {
        if (i == 0 && i2 == 0) {
          item2.active = true;
        } else {
          item2.active = false;
        }
        answers.push({
          id: item2.id,
          answer: null,
        })
      })
    })
    state.questions = questions;
    state.answers = answers;
  },

  [TYPES.RESET_QUESTINS](state, payload) {
    state.questions = null;
    state.answers = [];
  },

  [TYPES.ADD_ANSWER](state, payload) {
    let itemNum, questionNum, questionId;
    state.questions.map((item, i) => {
      if (item.active == true) {
        item.active = false;
        itemNum = parseInt(i);

        item.questions.map((item2, i2) => {
          if (item2.active == true) {
            item2.active = false;
            questionNum = parseInt(i2);
            questionId = item2.id;
          }
        })
      }
    })

    if (payload.type == 'next') {
      if (state.questions[itemNum].questions[questionNum+1]) {
        state.questions[itemNum].questions[questionNum+1].active = true;
        state.questions[itemNum].active = true;
      } else {
        if (state.questions[itemNum+1]) {
          state.questions[itemNum+1].active = true;
          state.questions[itemNum+1].questions[0].active = true;
        }
      }
      state.answers.map(item => {
        if (item.id == questionId) {
          item.answer = payload.answer;
        }
      })
    } else if (payload.type == 'prev') {
      if (state.questions[itemNum].questions[questionNum-1]) {
        state.questions[itemNum].questions[questionNum-1].active = true;
        state.questions[itemNum].active = true;
      } else {
        state.questions[itemNum-1].active = true;
        state.questions[itemNum-1].questions[state.questions[itemNum-1].questions.length-1].active = true;
      }
    }
  },
}

export default {
  namespaced,
  actions,
  state,
  mutations,
};
